import { useEffect, useState } from 'react';
import {
    Chart, Series, CommonSeriesSettings, Legend, ValueAxis, Title, Export, Tooltip, Font, Label, Format
} from 'devextreme-react/chart';
import CustomLegend from "./CustomLegend"
import { customizeTooltip, setSeriesList, getDynamicFields, sumByField, sumTotalJob } from './config';
import { useTranslation } from 'react-i18next'

let delayHighlighted: any, totalJobDefault = 0
const StackedBar = (props) => {
    const { t } = useTranslation(['dashboard'])
    let { dataSource } = props
    // let dataSource: any = RESULT_TEST
    const [highlighted, setHighlighted] = useState('')
    const [totalJob, setTotalJob] = useState(0)

    const chartFields: any = getDynamicFields(dataSource); // ใช้ใน Series
    const seriesList: any = setSeriesList(chartFields)

    useEffect(() => {
        setTotalJob(sumTotalJob(dataSource))
    }, [dataSource])

    return <div className="flex flex-col md:flex-row w-full">
        {/* Left column: 80% on medium screen and up */}
        <div className={`w-full md:w-5/6`}>
            <div className="text-left">
                <label className="text-primary-600 text-center text-xs font-semibold">
                    {`${t("number")} : ${totalJob}`}
                </label>
            </div>
            <Chart id="chart" dataSource={dataSource} animation={false}>
                {/* ใช้ series_name เป็นแกน x และ stackedBar เป็นประเภทกราฟ */}
                <CommonSeriesSettings
                    argumentField="series_name"
                    type="bar"
                >
                    <Label visible={highlighted !== ""}>
                        <Format type="fixedPoint" precision={0} />
                    </Label>
                </CommonSeriesSettings>

                {/* สร้าง Series ตามประเภทที่เจอในข้อมูล */}
                {seriesList.map((s) => (
                    <Series
                        key={s?.valueField}
                        valueField={s?.valueField}
                        name={s?.name}
                        color={s.color}
                        visible={highlighted && highlighted !== s.name ? false : true}
                    />
                ))}
                {/* {chartFields.map((field) => (
                <Series key={field} valueField={field} name={field} />
            ))} */}

                <ValueAxis position="left">
                    <Title text={t('number_of_delivery_points')} />
                    <Font size={14} weight={500} family="IBM Plex Sans Thai" />
                </ValueAxis>

                <Legend
                    visible={false}
                    verticalAlignment="top"
                    horizontalAlignment="center"
                    itemTextPosition="top"
                />


                <Export enabled={false} />
                <Tooltip
                    enabled={true}
                    location="edge"
                    customizeTooltip={customizeTooltip}
                />
            </Chart>
        </div>

        {/* Right column: 20% on medium screen and up */}
        <div className="w-full md:w-1/6  ml-2">
            <CustomLegend
                series={seriesList}
                onHover={(name) => {
                    clearTimeout(delayHighlighted)
                    delayHighlighted = setTimeout(() => {
                        setTotalJob(sumByField(dataSource, name))
                        setHighlighted(name)
                    }, 500);
                }}
                onLeave={() => {
                    delayHighlighted = setTimeout(() => {
                        setTotalJob(sumTotalJob(dataSource))
                        setHighlighted("")
                    }, 500);
                }}
            />
        </div>
    </div>
}

export default StackedBar;

const MOCKUP = [
    { state: 'JAN', data1: 210, data2: 150, data3: 310, data4: 200 },
    { state: 'FEB', data1: 180, data2: 240, data3: 280, data4: 120 },
    { state: 'MAR', data1: 300, data2: 190, data3: 260, data4: 150 },
    { state: 'APR', data1: 250, data2: 180, data3: 270, data4: 220 },
    { state: 'MAY', data1: 150, data2: 130, data3: 300, data4: 190 },
    { state: 'JUN', data1: 220, data2: 210, data3: 180, data4: 250 },
    { state: 'JUL', data1: 280, data2: 240, data3: 130, data4: 200 },
    { state: 'AUG', data1: 190, data2: 260, data3: 240, data4: 160 },
    { state: 'SEP', data1: 230, data2: 210, data3: 190, data4: 200 },
    { state: 'OCT', data1: 260, data2: 220, data3: 180, data4: 150 },
    { state: 'NOV', data1: 210, data2: 230, data3: 140, data4: 180 },
    { state: 'DEC', data1: 300, data2: 170, data3: 200, data4: 190 }
];

